<template>
  <v-card class="ma-5">

    <div class="d-flex">
      <div class="flex-grow-1">

        <v-card-item>
          <v-card-title class="text-headline-small">Contenuti disponibili</v-card-title>
        </v-card-item>



        
        <v-card-text v-if="runtimeStore.session.settings.packsDownloadLocation === 'filesystem'">
        <p >
          
          Hai impostato l'utilizzo del webserver per fornire le mappe e i richiami.<br>
          
          <v-divider class="my-3" />

          I files di cui hai bisogno potrebbero essere presenti nel percorso corretto, 
          se su questo dispositivo era già installato PNGP Tracker. <br>
          Percorso: /storage/0/emulated/.pngptracker/
          </p>
          

        </v-card-text>
          <v-card-text v-if="runtimeStore.session.settings.packsDownloadLocation === 'cache'">
           
           
          Questi pacchetti vengono scaricati nella cache (cache request).<br>
          Meglio eseguire le operazioni di download sotto copertura WIFI <v-icon size="x-small"
              class="ml-1">mdi-wifi</v-icon>
            <p v-if="packsStore.isBackgroundFetchSupported">
            <!-- <span class="mt-4 text-title-large">Chrome, Edge</span> -->
            Il tuo dispositivo supporta il download in background.
            <a href="https://developer.mozilla.org/en-US/docs/Web/API/Background_Fetch_API" target="_blank"
                rel="noopener" class="text-decoration-none"><v-icon size="small">mdi-information-outline</v-icon></a>
            <br>
            <span v-if="packsStore.useBackgroundFetch"></span>
            <span v-else>backgroundFetch è stato disabilitato nelle impostazioni</span>

          </p>
          <p v-if="!packsStore.isBackgroundFetchSupported">
            <!-- <span class="mt-4 text-title-large">Safari, Firefox</span> -->
            <!-- <v-icon color="yellow-darken-3" size="small">mdi-alert</v-icon>  -->
            Il dispositivo <strong>non</strong> supporta il download in background
            <a href="https://developer.mozilla.org/en-US/docs/Web/API/Background_Fetch_API" target="_blank"
                rel="noopener" class="text-decoration-none"><v-icon size="small">mdi-information-outline</v-icon></a>
            .<br>
            Il download avviene ad applicazione aperta ed in primo piano (non chiudere / nascondere l'applicazione
            durante il download).
          </p>





          <v-list item-props :lines="false" density="comfortable">

            <v-list-item v-for="(pack, index) in packsStore.availablePacks" :key="pack.id">

              <v-divider v-if="index == 0" class="mb-2"></v-divider>

              <v-list-item-title class="text-grey-darken-2 font-weight-bold">

                <v-icon :icon="pack.icon" class="x-small mr-3"></v-icon>
                <span>
                  {{ pack.title }}
                </span>

              </v-list-item-title>

              <v-list-item-subtitle>
                <p>
                  {{ pack.description }}<br>
                  dimensione:
                  <strong>
                    {{ bytesHumanReadable(pack.downloadTotal) }}
                  </strong>
                </p>

                <p class="d-flex align-center mt-1" v-if="pack.status == 'downloading'">

                  <v-progress-linear indeterminate :height="5" color="primary">
                  </v-progress-linear>

                </p>
              </v-list-item-subtitle>
              <div class="pl-5">


                <v-dialog width="auto" v-if="runtimeStore.session.settings.packsDownloadLocation === 'filesystem'">
                  <template v-slot:activator="{ props }">
                    <v-list-item-action start class="mr-5 mt-2">
                      <v-btn :id="'btn_' + index" size="size" variant="elevated" color="primary" class="pa-2 px-4"
                          v-bind="props">
                        <v-icon>mdi-download</v-icon>
                      </v-btn>
                      <label class="ml-2" :for="'btn_' + index">
                        Scarica su filesystem locale
                      </label>
                    </v-list-item-action>
                  </template>
                  <template v-slot:default="{ isActive }">

                    <v-card theme="dark" >
                      <v-card-title class="headline">Conferma</v-card-title>
                      <v-card-text>
                        <p>
                          Sei sicuro di voler scaricare su filesystem<br>"{{ pack.title }}"?
                        </p>
                      </v-card-text>

                      <v-card-actions class="flex-column">
                        <v-btn size="large" variant="elevated" color="green-darken-3"
                            @click="filesystemDownloadPack($event, pack); isActive.value = false">
                          <v-icon>mdi-check</v-icon>
                          Conferma</v-btn>
                        <v-btn size="large" variant="outlined" color="white" @click="isActive.value = false"
                            class="mx-0 my-3">
                          <v-icon>mdi-chevron-down</v-icon>
                          Indietro</v-btn>
                      </v-card-actions>
                    </v-card>


                  </template>
                </v-dialog>

                <v-dialog width="auto" v-if="runtimeStore.session.settings.packsDownloadLocation === 'cache'">
                  <template v-slot:activator="{ props }">
                    <v-list-item-action start class="mr-5">
                      <v-switch :id="'switch_' + index" hide-details :color="getSwitchColor(pack.status)" inset
                          v-model="pack.status" @click.prevent="" :valueComparator="setPackSwitchValue"
                          :loading="pack.status == 'downloading' ? 'grey' : false" v-bind="props">
                      </v-switch>
                      <label class="ml-2" :for="'switch_' + index">
                        Rendi disponibile via cache
                      </label>
                    </v-list-item-action>
                  </template>
                  <template v-slot:default="{ isActive }">

                    <v-card theme="dark" v-if="pack.status == 'not-cached'">
                      <v-card-title class="headline">Conferma</v-card-title>
                      <v-card-text>
                        <p>
                          Sei sicuro di voler scaricare in cache<br>"{{ pack.title }}"?
                        </p>
                      </v-card-text>

                      <v-card-actions class="flex-column">
                        <v-btn size="large" variant="elevated" color="green-darken-3"
                            @click="cacheDownloadPack(pack, isActive)">
                          <v-icon>mdi-check</v-icon>
                          Conferma</v-btn>
                        <v-btn size="large" variant="outlined" color="white" @click="isActive.value = false"
                            class="mx-0 my-3">
                          <v-icon>mdi-chevron-down</v-icon>
                          Indietro</v-btn>
                      </v-card-actions>
                    </v-card>


                    <v-card theme="dark" v-if="pack.status == 'cached'">
                      <v-card-title class="headline">Conferma</v-card-title>
                      <v-card-text>
                        <p>
                          Sei sicuro di voler eliminare <br>"{{ pack.title }}"?
                        </p>
                      </v-card-text>

                      <v-card-actions class="flex-column">
                        <v-btn size="large" variant="elevated" color="red-darken-3" @click="removePack(pack, isActive)">
                          <v-icon>mdi-close</v-icon>
                          Elimina</v-btn>
                        <v-btn size="large" variant="outlined" color="white" @click="isActive.value = false"
                            class="mx-0 my-3">
                          <v-icon>mdi-chevron-down</v-icon>
                          Indietro</v-btn>
                      </v-card-actions>
                    </v-card>

                    <v-card theme="dark" v-if="pack.status == 'downloading'">
                      <v-card-title class="headline">Conferma</v-card-title>
                      <v-card-text>
                        <p>
                          Sei sicuro di voler annullare il download di <br>"{{ pack.title }}"?
                        </p>
                      </v-card-text>

                      <v-card-actions class="flex-column">
                        <v-btn size="large" variant="elevated" color="red-darken-3"
                            @click="stopCacheDownload(pack, isActive)">
                          <v-icon>mdi-close</v-icon>
                          Annulla</v-btn>
                        <v-btn size="large" variant="outlined" color="white" @click="isActive.value = false"
                            class="mx-0 my-3">
                          <v-icon>mdi-chevron-down</v-icon>
                          Indietro</v-btn>
                      </v-card-actions>
                    </v-card>

                  </template>
                </v-dialog>


              </div>
              <v-divider class="mt-6"></v-divider>
            </v-list-item>
          </v-list>


        </v-card-text>


      </div>

    </div>

  </v-card>
</template>

<script setup>

import { onMounted, onUnmounted, ref } from "vue";

import { usePacksStore } from "@/store/packs.js";
import { useRuntimeStore } from "@/store/runtime"

const packsStore = usePacksStore();
const runtimeStore = useRuntimeStore();


const mce = ref();


mce.value = document.querySelector('#main-container')





// const mappa1 = ref(true);


// console.warn("! packsStore exposed!")
// window.packsStore = packsStore


const setPackSwitchValue = (value) => {

  if (value == 'cached')
    return true

  if (value == 'downloading')
    return true

  return false

}


const cacheDownloadPack = async (pack, isActive) => {
  await packsStore.downloadPack(pack, isActive)
}


const bytesHumanReadable = (bytes) => {

  if (!bytes) {
    return "size undefined"
  }

  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
}





const stopCacheDownload = async (pack, isActive) => {

  await packsStore.stopCacheDownload(pack)
  packsStore.checkFilePacksTree()
  isActive.value = false
}




const removePack = async (pack, isActive) => {
  await packsStore.removePack(pack)
  packsStore.checkFilePacksTree()
  isActive.value = false
}


const getSwitchColor = (status) => {
  // console.log(status)
  if (status == 'cached')
    return "green"
  if (status == 'downloading')
    return "green"
  if (status == 'not-cached')
    return "gray-darken-2"

  return "blue"

}


const messageHandler = async (event) => {
  if (event.data && event.data.type === 'backgroundFetchSuccess') {
    const info = event.data.info;
    console.log('📦 Background Fetch Success in Main Window', info);
    packsStore.checkFilePacksTree()
  }

}

const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const filesystemDownloadPack = async (e, pack) => {

  console.log(e, pack)

  const urls = pack.files.map(f => {
    return `${f.url}`
  })

  // const confirmation = confirm(`Convermi di voler scaricare\n ${pack.title},\n ovvero ${urls.length} files?`)

  // if (!confirmation) {
  //   return
  // }

  for (const url of urls) {
    console.log(url)

    const a = document.createElement('a')
    a.style.display = 'none'
    document.body.appendChild(a)
    a.href = url
    a.download = url.split('/').pop()
    a.click()

    await sleep(500)
    // window.URL.revokeObjectURL(a.href)
    // document.body.removeChild(a)
  }
}



onMounted(() => {




  packsStore.checkFilePacksTree()
  // console.log("lures",lures.value)

  navigator?.serviceWorker.addEventListener('message', messageHandler);

  navigator?.serviceWorker.ready.then(async (swReg) => {
    if (swReg?.backgroundFetch) {
      const ids = await swReg.backgroundFetch.getIds();
      console.log("bgFetches ids are", ids)

      const bgFetches = {}

      for (const id of ids) {
        bgFetches[id] = await swReg.backgroundFetch.get(id);
        bgFetches[id].addEventListener('success', () => {
          packsStore.checkFilePacksTree()
          console.log("success for bgFetch with id ", id)
        });
      }
    }
  })
})

onUnmounted(() => {
  navigator?.serviceWorker.removeEventListener('message', messageHandler)
})

</script>

<style scoped>
/* :deep(.v-expansion-panel-title) {
  padding-left: .3em;
}

:deep(.v-expansion-panel-text__wrapper) {
  padding-left: .5em;
}*/
</style>
